var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:`${_vm.carbonPrefix}--overflow-menu ${_vm.carbonPrefix}--toolbar-action`,attrs:{"type":"button"}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }